import ProfilePage from "components/profile";
import Activity from "pages/activityLogs";
import Attributes from "pages/attributes";
import BusinessManagment from "pages/business";
import Categories from "pages/categories";
import Dashboard from "pages/dashboard";
import LoanProviderDashboard from "pages/dashboard/loanProviderDashboard";
import Distributors from "pages/distributors";
import RegisterPage from "pages/driver";
import Drivers from "pages/driver/index";
import DeliveryPartnerTerms from "pages/driver_terms";
import DropOffs from "pages/dropoffs";
import Feedbacks from "pages/feedbacks";
import FeedbackTypes from "pages/feedbacks/feedback_type";
import LoanRequests from "pages/loan";
import LoanRequestReport from "pages/loan/loanRequestReport";
import LoanAccounts from "pages/loanAccounts";
import LoanApplications from "pages/loanApplications";
import LoanCategories from "pages/loanCategory";
import LoanPayments from "pages/loanPayments";
import LoanProducts from "pages/loanProduct";
import LoanProviders from "pages/loanProvider";
import WarhouseManagerDashboard from "pages/managerDashboard";
import Microfinances from "pages/microFinance";
import Orders from "pages/orders";
import Products from "pages/products";
import ProductReturn from "pages/products/productReturn";
import SupplierProducts from "pages/products/supplierProducts";
import MyProductReturn from "pages/products/userProductReturn";
import ProductSkus from "pages/productSkus";
import Regions from "pages/regions";
import CommissionStats from "pages/report/commission";
import DriverTransactions from "pages/report/driverTransaction";
import InventoryReport from "pages/report/inventoryReport";
import ManagerSalesReport from "pages/report/managerReport";
import RetailerTransactions from "pages/report/retailerTransaction";
import SalesReport from "pages/report/salesReport";
import SmeSupplierTransactions from "pages/report/smeSupplierTransaction";
import SupplierTransactions from "pages/report/supplierTransaction";
import RetailerTerms from "pages/retailer_terms";
import Retailers from "pages/retailers";
import RetailerAgents from "pages/retailers/agents";
import Sales from "pages/sales";
import Config from "pages/settings/config";
import PaymentTypes from "pages/settings/payment_types";
import Roles from "pages/settings/roles";
import Shipments from "pages/shipments";
import Staffs from "pages/staffs";
import Stocks from "pages/stocks";
import Suppliers from "pages/supplier";
import SmeSuppliers from "pages/supplier/smeSupplier";
import SmeSupplierBusinesses from "pages/supplier/smeSupplierBusinesses";
import SupplierBusiness from "pages/supplier/supplier_business";
import SupplierCommission from "pages/supplier/supplier_commissions";
import SupplierTerms from "pages/supplier_terms";
import Transactions from "pages/transactions";
import SupplierPayout from "pages/transactions/supplierPayout";
import MyOrders from "pages/userorders";
import Users from "pages/users";
import Vehicles from "pages/vehicles";
import VehicleTypes from "pages/vehicleTypes";
import Wallets from "pages/wallets";
import WarehouseManagers from "pages/warehouseManager";
import Warehouses from "pages/warehouses";
import WarehouseShipping from "pages/warehouseShipping";
import { Route, Routes } from "react-router-dom";
import Login from "./pages/login";
import LoanProviderStaff from "pages/loanProviderStaff";
import { rolePermissions } from "utiles/permissions";
const RoutesComp = () => {
  const roles = JSON.parse(localStorage.getItem("roles")) || [];
  const isMaker = rolePermissions.hasMaker(roles);
  const isChecker = rolePermissions.hasChecker(roles);
  const hasManagerPermission = roles.some(
    (permission) => permission === "warehouse_manager",
  );
  const isLoanProvider = roles.includes("loan_provider");

  return (
    <Routes>
      <Route
        path="/"
        element={
          isMaker || isChecker ? (
            <LoanApplications />
          ) : isLoanProvider ? (
            <LoanProviderDashboard />
          ) : hasManagerPermission ? (
            <WarhouseManagerDashboard />
          ) : (
            <Dashboard />
          )
        }
      />
      <Route
        path="/dashboard"
        element={
          isMaker || isChecker ? (
            <LoanApplications />
          ) : isLoanProvider ? (
            <LoanProviderDashboard />
          ) : hasManagerPermission ? (
            <WarhouseManagerDashboard />
          ) : (
            <Dashboard />
          )
        }
      />
      <Route
        path="/loan-provider-dashboard"
        element={<LoanProviderDashboard />}
      />
      <Route path="/categories" element={<Categories />} />
      <Route path="/products" element={<Products />} />
      <Route path="/productvariants" element={<ProductSkus />} />
      <Route path="/regions" element={<Regions />} />
      <Route path="/retailers" element={<Retailers />} />
      <Route path="/warehouses" element={<Warehouses />} />
      <Route path="/distributors" element={<Distributors />} />
      <Route path="/stocks" element={<Stocks />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/shipments" element={<Shipments />} />
      <Route path="/wallets" element={<Wallets />} />
      <Route path="/drivers" element={<Drivers />} />
      <Route path="/vehicle_types" element={<VehicleTypes />} />
      <Route path="/vehicles" element={<Vehicles />} />
      <Route path="/users" element={<Users />} />
      <Route path="/dropoffs" element={<DropOffs />} />
      <Route path="/login" element={<Login />} />
      <Route path="/sales" element={<Sales />} />
      <Route path="/feedbacks" element={<Feedbacks />} />
      <Route path="/feedback-types" element={<FeedbackTypes />} />
      <Route path="/config" element={<Config />} />
      <Route path="/activity-logs" element={<Activity />} />
      <Route path="/payment-types" element={<PaymentTypes />} />
      <Route path="/roles" element={<Roles />} />
      <Route
        path="/sales-report"
        element={
          hasManagerPermission ? <ManagerSalesReport /> : <SalesReport />
        }
      />

      <Route path="/suppliers" element={<Suppliers />} />
      <Route path="/sme-suppliers" element={<SmeSuppliers />} />
      <Route
        path="/sme-supplier-business"
        element={<SmeSupplierBusinesses />}
      />
      <Route path="/commission" element={<SupplierCommission />} />
      <Route path="/sme-commission" element={<SupplierCommission isSme />} />
      <Route path="/supplier-business" element={<SupplierBusiness />} />
      <Route path="/warehouse-managers" element={<WarehouseManagers />} />
      <Route path="/business-managment" element={<BusinessManagment />} />
      <Route path="/warehouse-shipping" element={<WarehouseShipping />} />
      <Route path="/my-orders" element={<MyOrders />} />
      <Route path="/attributes" element={<Attributes />} />
      <Route path="/driver-transactions" element={<DriverTransactions />} />
      <Route path="/retailer-transactions" element={<RetailerTransactions />} />
      <Route path="/transactions" element={<Transactions />} />
      <Route path="/product-return" element={<ProductReturn />} />
      <Route path="/myproduct-return" element={<MyProductReturn />} />
      <Route path="/agents" element={<RetailerAgents />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/retailer_terms" element={<RetailerTerms />} />
      <Route path="/supplier_terms" element={<SupplierTerms />} />
      <Route path="/driver_terms" element={<DeliveryPartnerTerms />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/loans-requests" element={<LoanRequests />} />
      <Route path="/loan-providers" element={<LoanProviders />} />
      <Route path="/loan-categories" element={<LoanCategories />} />
      <Route path="/loan-products" element={<LoanProducts />} />
      <Route path="/loan-applications" element={<LoanApplications />} />
      <Route path="/loan-accounts" element={<LoanAccounts />} />
      <Route path="/loan-payments" element={<LoanPayments />} />
      <Route path="/loan-provider-staff" element={<LoanProviderStaff />} />
      <Route path="/supplier-products" element={<SupplierProducts />} />
      <Route path="/staffs" element={<Staffs />} />
      <Route path="/supplier-transactions" element={<SupplierTransactions />} />
      <Route
        path="/sme-supplier-transactions"
        element={<SmeSupplierTransactions />}
      />
      <Route path="/commissions" element={<CommissionStats />} />
      <Route path="/micro-finances" element={<Microfinances />} />
      <Route path="/supplier-payouts" element={<SupplierPayout />} />
      <Route path="/sme-supplier-payouts" element={<SupplierPayout isSme />} />
      <Route path="/retailer-loans" element={<LoanRequestReport />} />
      <Route path="/inventory-report" element={<InventoryReport />} />
    </Routes>
  );
};

export default RoutesComp;
